_getUserGiftSubscriptionsWithDetailsThunk